module.exports = __webpack_public_path__ + "static/five-7f9cbf39a813a8296c156b85cbca92e0.png";